import {Box, SxProps} from '@mui/material';

import {EmpionTooltip} from '../EmpionTooltip/EmpionTooltip';

import {orangeColors} from '../../layouts/theme/designSystem';

interface Props {
  percent: number;
  detailedCardView?: boolean;
  typography?: JSX.Element;
  sx?: SxProps;
}

export const ProgressBar = ({percent, detailedCardView, typography, sx}: Props) => {
  const minWidthForText = 20; // Minimum percentage width to show text inside

  return (
    <Box
      className='transition-all'
      sx={{
        backgroundColor: orangeColors[detailedCardView ? 5 : 4],
        width: '100%',
        minHeight: '40px',
        borderRadius: '40px',
        padding: '4px',
        position: 'relative',
        ...sx,
      }}
    >
      <EmpionTooltip title={`${percent}%`} isEnabled={!typography}>
        <Box
          width={`${percent}%`}
          height='32px'
          borderRadius='40px'
          sx={{background: `linear-gradient(90deg, ${orangeColors[70]} 0%, ${orangeColors[900]} 70%)`, ...sx}}
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          {typography && percent >= minWidthForText && typography}
        </Box>
      </EmpionTooltip>
      {typography && percent < minWidthForText && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '16px',
            transform: 'translateY(-50%)',
            whiteSpace: 'nowrap',
          }}
        >
          {typography}
        </Box>
      )}
    </Box>
  );
};
